/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]!) : null;
};

type CookieDuration = { days?: number; minutes?: number };

const MINUTES_PER_DAY = 24 * 60;
const MILLISECONDS_PER_MINUTE = 60 * 1000;

export const setCookie = (
  name: string,
  value: string,
  duration: CookieDuration,
): void => {
  if (typeof document === 'undefined') return;
  const { days = 0, minutes = 0 } = duration;
  const ms = (days * MINUTES_PER_DAY + minutes) * MILLISECONDS_PER_MINUTE;
  const expires = new Date(Date.now() + ms);
  const isLocalhost =
    location.hostname === 'localhost' || location.hostname === '127.0.0.1';
  const secure = isLocalhost ? '' : '; Secure';
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secure}`;
};
